const Contact = () => {
  return <div>Contact page</div>
}

export { Contact }
